import React from "react";
import { twMerge } from "tailwind-merge";
import StickyBar from "../ui/StickyBar";

/**
 * Thumb-zone action row for host onboarding steps.
 * Mobile: fixed bottom. Desktop: inline at end of step (caller renders desktop twin).
 */
export default function HostOnboardingStickyActions({
  children,
  testId = "host-onboarding-sticky",
  className = "",
}) {
  return (
    <StickyBar
      testId={testId}
      hideOnDesktop
      className={twMerge("z-50", className)}
      aria-label="Onboarding actions"
      innerClassName="w-full"
    >
      <div className="flex w-full items-stretch gap-2">{children}</div>
    </StickyBar>
  );
}

/** Shared classes for the desktop twin of sticky actions. */
export const ONBOARDING_DESKTOP_ACTIONS =
  "hidden sm:flex flex-wrap items-center justify-between gap-2 pt-1";

/** Page bottom padding so sticky actions don’t cover content. */
export const ONBOARDING_STICKY_PAGE_PB =
  "pb-[calc(5.75rem+env(safe-area-inset-bottom))] sm:pb-[max(2rem,env(safe-area-inset-bottom))]";
